<template>
    <div class="container" id="Meeting" @mousemove="mousemove">
        <header class="header" :class="[is_move>5?'shrink':'']" :style="{'width':(right_show?'calc(100% - 16rem)':'100%')}">
            <div class="header-item">
                <img alt="" src="/static/images/logo_l.png">
                <span class="logo">X300 Manager 视频通话</span>
            </div>
            <div class="header-item">
                <i style="margin-right: 6px;margin-top:-2px;line-height: 0;" v-show="password != ''">
                    <svg viewBox="64 64 896 896" class="" data-icon="lock" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M832 464h-68V240c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zM540 701v53c0 4.4-3.6 8-8 8h-40c-4.4 0-8-3.6-8-8v-53a48.01 48.01 0 1 1 56 0zm152-237H332V240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v224z"></path></svg>
                </i>
                <span class="room">{{room}}</span>
            </div>
            <div class="header-item header-item__version"><span @click="show_version">{{version[version_num]}}</span></div>
        </header>

        <main class="main">
            <div style="position: absolute; width: 240px; height: 140px; right: 0.5rem; top: 3.5rem; z-index: 10;">
                <div style="z-index: 10; position: absolute; right: 0px; top: 0px;">
                    <img @click="close_video" :src="show_main_video?'/static/images/close_video.png':'/static/images/close_people.png'" style="width: 28px; height: 28px;" alt="">
                </div>
                <div v-bind:class="{'agora-player__box':true, 'cover':true,'video_show':show_main_video,'video_hide':!show_main_video}" id="agora-player-main" style="width: 100%; height: 100%; border-radius: 4px; transition: all 0.1s ease-in-out 0s; float: right;">
                    <div class="drag1"></div>
                    <div class="drag3"></div>
                </div>
            </div>
            <div v-for="item in mainList" class="agora-player__box contain" :id="item" style="width: 100%; height: 100%; position: absolute; right: 0px; top: 0px;">

            </div>
            <!--
            <img v-show="mainList" style="position: absolute;top: 3rem;left: 2rem;width: 8rem;" src="/static/images/water.png" alt="">-->
        </main>

        <footer class="footer" :class="[is_move>5?'hide':'']" :style="{'width':(right_show?'calc(100% - 16rem)':'100%')}">
            <div class="footer-item">
                <div class="icon-btn">
                    <img class="icon-btn--inactive" src="/static/images/list.png" alt="" @click="left_show=!left_show;">
                </div>
            </div>
            <div class="footer-item">
                <div class="icon-btn">
                    <img @click="upd_audio" :src="audio?'/static/images/audio.png':'/static/images/audio1.png'" alt="">
                </div>
                <div class="icon-btn">
                    <img @click="upd_video" :src="video?'/static/images/video.png':'/static/images/video1.png'" alt="">
                </div>
                <div class="icon-btn">
                    <img @click="set_leave" src="/static/images/down.png" alt="">
                </div>
                <div class="icon-btn">
                    <el-popover
                            placement="top-start"
                            width="118"
                            trigger="click"
                            popper-class="ant-dropdown"
                            >
                        <ul class="ant-dropdown-menu">
                            <li class="ant-dropdown-menu-item" @click="show_setting=1;device()">音视频设置</li>
                            <li class="ant-dropdown-menu-item" @click="show_setting=2;">房间设置</li>
                        </ul>
                        <img slot="reference" src="/static/images/setting.png" alt="">
                    </el-popover>
                </div>
                <div class="icon-btn">
                    <el-popover
                            placement="top-start"
                            trigger="hover"
                            content="功能开发中">
                        <img slot="reference" src="/static/images/screen.png" alt="">
                    </el-popover>
                </div>
            </div>
            <div class="footer-item">
                <div class="icon-btn">
                    <el-badge :value="unread" :hidden="!unread" class="item">
                        <img @click="set_right_mess" :src="mess?'/static/images/message.png':'/static/images/message1.png'" alt=""/>
                    </el-badge>
                </div>
                <div class="icon-btn">
                    <img @click="set_right_people" :src="people?'/static/images/people.png':'/static/images/people1.png'" alt="">
                </div>
            </div>
        </footer>
        <!--右侧-->
        <div class="right-panel" :style="{'right':right_show?'0px':'-16rem'}">
            <div class="message-list-container" v-show="!people" :style="{'height':(!people?(!mess?'50%':'100%'):'0%')}">
                <div class="message-list-header">
                    <span>参加者({{userInfo.length}})</span>
                    <i @click="set_right_people" class="anticon" style="position: absolute; left: 15px; width: 22px; height: 22px; top: 14px; cursor: pointer;">
                        <img src="/static/images/close.png" alt="">
                    </i>
                </div>
                <div class="ant-divider ant-divider-horizontal" style="margin: 3px 0px;"></div>
                <div class="user-list-box">
                    <div v-for="item in userInfo" class="user-item">

                        <div class="user-info">
<!--                            <span class="ant-avatar ant-avatar-circle ant-avatar-image">-->
<!--                                <img src="https://videocall.agora.io/usrservice/v1/account/portrait?portraitId=1">-->
<!--                            </span>-->
                            <span style="margin-left: 6px;">{{item.uid}}</span>
                        </div>
                        <div class="user-control" v-if="item.uid==rtc.params.uid">
                            <i class="anticon" style="width: 28px; height: 28px; cursor: pointer; display: flex; justify-content: center; align-items: center; pointer-events: none; opacity: 0.5;">
                                <img src="/static/images/signout.png" alt="mic control" style="width: 30px;">
                            </i>
                            <i class="anticon" style="width: 28px; height: 28px; cursor: pointer; display: flex; justify-content: center; align-items: center;">
                                <img @click="upd_video" :src="item.video?'/static/images/video.png':'/static/images/video1.png'" alt="camera control" style="width: 30px;">
                            </i>
                            <i class="anticon" style="width: 28px; height: 28px; cursor: pointer; display: flex; justify-content: center; align-items: center;">
                                <img @click="upd_audio" :src="item.audio?'/static/images/audio.png':'/static/images/audio1.png'" alt="mic control" style="width: 30px;">
                            </i>
                        </div>
                        <div class="user-control" v-else>
                            <i @click="move_people(item.uid)" class="anticon" style="width: 28px; height: 28px; cursor: pointer; display: flex; justify-content: center; align-items: center; opacity: 1;">
                                <img src="/static/images/signout.png" alt="mic control" style="width: 30px;">
                            </i>
                            <i @click="upd_other_media(item.uid,'video')" class="anticon" style="width: 28px; height: 28px; cursor: pointer; display: flex; justify-content: center; align-items: center;">
                                <img :src="item.video?'/static/images/video.png':'/static/images/video1.png'" alt="camera control" style="width: 30px;">
                            </i>
                            <i @click="upd_other_media(item.uid,'audio')" class="anticon" style="width: 28px; height: 28px; cursor: pointer; display: flex; justify-content: center; align-items: center;">
                                <img :src="item.audio?'/static/images/audio.png':'/static/images/audio1.png'" alt="mic control" style="width: 30px;">
                            </i>
                        </div>
                    </div>
                    <div class="ant-divider ant-divider-horizontal" style="margin: 3px 0px;"></div>
                </div>
            </div>
            <div class="message-list-container" v-show="!mess" :style="{'height':(!mess?(!people?'50%':'100%'):'0%')}">
                <div class="message-list-header">
                    <span>消息内容</span>
                    <i @click="set_right_mess" class="anticon" style="position: absolute; left: 15px; width: 22px; height: 22px; top: 14px; cursor: pointer;">
                        <img src="/static/images/close.png" alt="">
                    </i>
                </div>
                <div class="ant-divider ant-divider-horizontal"></div>
                <div class="message-list-box">
                    <div :class="[item.self?'message-item-sender':'message-item']" v-for="item in messageList">
                        <div class="message-label">{{item.nickname}}</div>
                        <div class="message-detail">{{item.message}}</div>
                    </div>
                </div>
                <div class="message-control" style="width: 100%">
                    <el-col :span="18">
                        <el-input size="small" placeholder="消息输入" v-model="message"></el-input>
                    </el-col>
                    <el-col :span="6" style="padding-left: 10px;">
                        <el-button size="small" type="primary" @click="send_message">发送</el-button>
                    </el-col>
                </div>
            </div>
        </div>
        <!--左侧-->
        <div class="carousel expanded" :class="{collapsed:!left_show}" @mousemove="mousemoveLeft">
            <div class="backdrop"></div>
            <div class="side-panel">
                <div class="vpanel-control-wrapper" @click="left_show=!left_show;">
                    <div class="control"></div>
                </div>
            </div>
            <ul class="container" ref="movieLeft">
                <div class="agora-player__box cover carousel-item" v-for="(item,index) in userInfo"
                 v-if="item.uid != rtc.params.uid && item.Streams_id != mainList[0]" @click="move_main(item.Streams_id)">
                    <i style="position: absolute;z-index:9;top: 5px;left:5px;" v-show="item.TransportDelay > 100">
                        <svg :fill="[item.TransportDelay < 200?'#E6A23C':'#F56C6C']" t="1576761221239" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1215" width="24" height="24"><path d="M177.9 349.5c-0.1-54.6 21.2-107.1 59.4-146.1 8.4-8.4 11.6-20.6 8.4-32-3.2-11.4-12.2-20.2-23.7-23.1-11.5-2.9-23.6 0.6-31.8 9.2-105.5 108-104.1 280.8 3 387.1 12.9 12.8 33.7 12.8 46.5-0.1 12.8-12.9 12.8-33.7-0.1-46.6-39.6-39.2-61.8-92.6-61.7-148.4z m490.9-124.6c-13.1 12.6-13.5 33.4-0.9 46.5 42.7 44.5 41.8 114.9-2 158.3-8.6 8.2-12.2 20.5-9.2 32 2.9 11.5 11.9 20.6 23.4 23.7 11.5 3.1 23.8-0.3 32.1-8.9 69.3-68.6 70.8-180.2 3.2-250.6-6-6.3-14.3-9.9-23.1-10.1-8.7-0.2-17.2 3.1-23.5 9.1z m0 0" p-id="1216"></path><path d="M833.3 157.5c-8.2-8.6-20.3-12.1-31.8-9.2-11.5 2.9-20.5 11.7-23.7 23.1-3.2 11.4 0 23.6 8.4 32 80.1 82.1 79.1 213.5-2.3 294.4-12.9 12.8-13 33.7-0.1 46.5 12.8 12.9 33.7 13 46.6 0.1 106.9-106.2 108.2-278.9 2.9-386.9zM357.9 476.3c12.8-12.9 12.7-33.8-0.2-46.5-43.8-43.3-44.7-113.8-2-158.3 12.6-13.1 12.2-34-0.9-46.5-13.1-12.6-34-12.2-46.5 0.9-67.6 70.4-66.1 182 3.2 250.6 12.7 12.8 33.6 12.7 46.4-0.2z m202-50c32.1-21.4 46.4-61.3 35.3-98.2-11.1-36.9-45-62.3-83.6-62.5-38.6-0.2-72.8 24.8-84.3 61.6s2.4 76.8 34.3 98.6L313.8 831.9c-6.2 17.1 2.6 35.9 19.7 42.2 17.1 6.2 35.9-2.7 42.2-19.7l31.3-85.9h207.4l32 88c5.7 15.4 22.7 23.4 38.1 17.8l6-2.2c15.4-5.7 23.4-22.7 17.8-38.1L559.9 426.3z m-49.3 57.2l39.8 109.4h-79.6l39.8-109.4z m-82.4 226.4l21.3-58.5h122.2l21.3 58.5H428.2z m0 0" p-id="1217"></path></svg>
                    </i>
                    <div :id="item.Streams_id" style="width: 100%;height: 100%;"></div>
                    <div class="agora-player__label" v-text="item.uid"></div>
                </div>
            </ul>

            <div class="scrollBtn scrollUp animation-appear" @click="move_video('up')" v-show="is_left < 5"></div>
            <div class="scrollBtn scrollDown animation-appear" @click="move_video('down')" v-show="is_left < 5"></div>
        </div>

        <div class="with-modal-mask" v-show="show_setting">
            <!--设置设备ID弹窗-->
            <div class="ant-card" v-show="show_setting == 1">
                <div class="ant-card-body">
                    <header style="height: 40px;">
                        <div style="display: flex; align-items: center; justify-content: space-around; font-size: 18px;">
                            <i @click="set_local_leave();show_setting=0;" class="el-icon-back" style="cursor: pointer;"></i>
                            <span style="font-weight: bold; text-align: center; flex-grow: 1;">设置您的设备</span>
                        </div>
                    </header>

                    <div class="ant-divider-horizontal"></div>

                    <div>
                        <div class="audio-setting">
                            <div class="audio-setting-label">麦克风</div>
                            <div class="audio-setting-desc">
                                <span>发出声音以检查麦克风是否工作。</span>
                            </div>
                            <div class="audio-setting-select ant-select ant-select-enabled">
                                <el-select v-model="audio_id" @change="set_audio">
                                    <el-option
                                            v-for="item in device_audio"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="video-setting">
                            <div class="video-setting-left">
                                <div class="video-setting-label">相机</div>
                                <div class="video-setting-desc">
                                    <span>移至相机前面以检查其是否有效。</span>
                                </div>
                                <div class="video-setting-select ant-select ant-select-enabled">
                                    <el-select v-model="video_id" @change="set_video">
                                        <el-option
                                                v-for="item in device_video"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                            <div class="video-setting-right">
                                <div class="preview-window" :id="preview">

                                </div>
                            </div>
                        </div>
                        <div class="ant-divider-horizontal"></div>
                        <div class="video-setting-label">解析度</div>
                        <el-radio-group v-model="Resolution" @change="set_Profile">
                            <el-radio label="0">低</el-radio>
                            <el-radio label="1">标准</el-radio>
                            <el-radio label="2">高</el-radio>
                        </el-radio-group>
                        <div class="ant-divider-horizontal"></div>
                        <el-button size="small" type="primary" style="width: 100%;">
                            上传日志
                        </el-button>
                        <div class="ant-divider-horizontal"></div>
                        <el-button @click="submitDevice" size="small" type="primary" style="width: 100%;">
                            确认
                        </el-button>
                    </div>
                </div>
            </div>
            <!--设置密码-->
            <div class="ant-card" v-show="show_setting == 2">
                <div class="ant-card-body">
                    <header style="height: 40px;">
                        <div style="display: flex; align-items: center; justify-content: space-around; font-size: 18px;">
                            <i @click="show_setting=0;" class="el-icon-back" style="cursor: pointer;"></i>
                            <span style="font-weight: bold; text-align: center; flex-grow: 1;">房间设置</span>
                        </div>
                    </header>
                    <div class="ant-divider-horizontal"></div>
                    <div>
                        <el-row style="line-height: 40px;font-weight: bold;">
                            <el-col :span="16" style="text-align: left;">
                                房间名称
                            </el-col>
                            <el-col :span="8" style="text-align: right;">
                                {{room}}
                            </el-col>
                        </el-row>
                        <el-row style="line-height: 40px;font-weight: bold;">
                            <el-col :span="9" style="text-align: left;">
                                房间密码
                            </el-col>
                            <el-col :span="15" style="text-align: right;">
                                <el-input size="small" v-model="password" placeholder="Input the password." show-password>
<!--                                    <template slot="append" style="padding: 0 10px;cursor: pointer;"><i class="el-icon-view"></i></template>-->
                                </el-input>
                            </el-col>
                        </el-row>
                        <div class="ant-divider-horizontal"></div>
                        <el-row style="line-height: 40px;font-weight: bold;">
                            <el-col :span="16" style="text-align: left;">
                                默认情况下允许摄像头
                            </el-col>
                            <el-col :span="8" style="text-align: right;">
                                <el-switch v-model="default_camera">
                                </el-switch>
                            </el-col>
                        </el-row>
                        <el-row style="line-height: 40px;font-weight: bold;">
                            <el-col :span="16" style="text-align: left;">
                                默认情况下允许麦克风
                            </el-col>
                            <el-col :span="8" style="text-align: right;">
                                <el-switch v-model="default_microphone">
                                </el-switch>
                            </el-col>
                        </el-row>
                        <div class="ant-divider-horizontal"></div>
                        <el-row style="margin-bottom: 6px;line-height: 40px;">
                            <el-col :span="9" style="text-align: left;">
                                主持人
                            </el-col>
                            <el-col :span="15" style="text-align: right;">
                                未设置
                            </el-col>
                        </el-row>
                        <el-button size="small" type="primary" style="width: 100%;">
                            申请成为主持人
                        </el-button>
                        <div class="ant-divider-horizontal"></div>
                        <el-button size="small" type="primary" style="width: 100%;">
                            上传日志
                        </el-button>
                        <div class="ant-divider-horizontal"></div>
                        <el-button @click="submitPassword" size="small" type="primary" style="width: 100%;">
                            确定
                        </el-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Main',
        data () {
            return {
                rtc: {
                    client: null,
                    joined: false,
                    published: false,
                    localStream: null,
                    remoteStreams: [],
                    params: {},
                    otherStreams:[],
                },
                rtm:{
                    client:null,
                },
                option: {
                    appID: "dfd486935afe44c8a10af64c3e06752f", //声网appID 后期需自行替换
                    channel: "",
                    uid: null,
                    token: null
                },//参数

                video_type: [
                    '480p_4',
                    '720p_3',
                    '1080p_2',
                ],//画质字典
                avatar: [
                    '/static/images/avatar1.png',
                    '/static/images/avatar2.png',
                    '/static/images/avatar3.png',
                    '/static/images/avatar4.png',
                    '/static/images/avatar5.png',
                    '/static/images/avatar6.png',
                    '/static/images/avatar7.png',
                    '/static/images/avatar8.png',
                    '/static/images/avatar9.png',
                    '/static/images/avatar10.png',
                    '/static/images/avatar11.png',
                    '/static/images/avatar12.png',
                    '/static/images/avatar13.png',
                    '/static/images/avatar14.png',
                    '/static/images/avatar15.png',
                    '/static/images/avatar16.png',
                ],//头像字典
                default_microphone: true,//
                default_camera: true,
                room:'',//房间号
                password:'',//密码
                Resolution: "0",//画质
                show_setting:0,
                device_video: [],
                device_audio:[],
                video_id: '',//视频设备ID
                audio_id: '',//音频设备ID
                preview:'',
                video:true,//是否播放视频
                audio:true,//是否播放音频
                avatar_id:0,//头像ID
                nickname:'',//昵称
                show_main_video:true,//是否显示自己视频
                left_show: true,//左侧是否显示
                right_show:false,
                mess:true,
                people:true,
                userInfo:[],//用户信息（昵称、头像）
                mainList:[],//主视频页面
                message:'',//消息输入框
                channel:[],//RTM频道
                messageList:[],//消息列表
                stream:'',
                local:{
                    client: null,
                },
                version:[
                    '版本: 1.0.0',
                ],
                version_num:0,
                unread: 0,//未读消息
                is_move:0,//是否隐藏上下
                is_left:0,//是否隐藏左侧上下滑动
            }
        },
        mounted(){
            let that = this;
            //设置默认属性
            that.video = (localStorage.getItem('video') && localStorage.getItem('video')) === 'false' ? false : true;
            that.audio = (localStorage.getItem('audio') && localStorage.getItem('audio') === 'false') ? false : true;
            that.avatar_id = localStorage.getItem('avatar') ? localStorage.getItem('avatar') : 0;
            that.nickname = localStorage.getItem('nickname');
            that.room = localStorage.getItem('room');
            that.password = localStorage.getItem('password');
            that.default_microphone = (localStorage.getItem('default_microphone') && localStorage.getItem('default_microphone')) === 'false' ? false : true;
            that.default_camera = (localStorage.getItem('default_camera') && localStorage.getItem('default_camera')) === 'false' ? false : true;

            that.video_id = localStorage.getItem('video_id');
            that.audio_id = localStorage.getItem('audio_id');
            that.Resolution = localStorage.getItem('resolution');

            that.option.channel = localStorage.getItem('room');

            that.version.push('RTC: '+that.AgoraRTC.VERSION);
            that.version.push('RTM: '+that.AgoraRTM.VERSION);

            //设置uid
//            that.option.uid = Math.floor(Math.random()*10000)+'_'+encodeURI(that.nickname)+'_'+that.avatar_id;

            that.rtc.client = that.AgoraRTC.createClient({mode: "rtc", codec: "h264"});
/*
            that.rtc.client.setEncryptionMode('aes-256-xts');
            if (that.password) {
                that.rtc.client.setEncryptionSecret(that.password);
            }
*/
            that.rtm.client = that.AgoraRTM.createInstance(that.option.appID);
            that.channel = that.rtm.client.createChannel(that.option.channel);

            //获取token
            that.$http.get('https://api.x300.xloong.com/index.php?api=get_rtc_token&hubName=xloong&uid=0&channelName=' + that.room)
                .then(function (response) {
                    that.option.token = response.data.data
                    console.log(response);

                    // Initialize the client
                    that.rtc.client.init(that.option.appID, function () {
                        that.rtc.client.on("stream-added", function (evt) {
                            var remoteStream = evt.stream;
                            console.log(remoteStream);
                            var id = remoteStream.getId();

                            that.userInfo.push({
                                'uid': id,
                                'video': true,
                                'audio': true,
                                'Streams_id': 'video_' + id,
                                'TransportDelay': 1,
                            });

                            var Streams_id = 'video_' + id;
                            if (!that.rtc.otherStreams[Streams_id])
                                that.rtc.otherStreams[Streams_id] = remoteStream;

                            if (that.mainList.length === 0) {
                                that.mainList[0] = Streams_id;
                            }

                            if (id !== that.rtc.params.uid) {
                                that.rtc.client.subscribe(remoteStream, function (err) {
                                    console.log("stream subscribe failed", err);
                                });

                                that.rtc.client.on("stream-subscribed", function (evt) {
                                    that.$nextTick(function () {
                                        that.rtc.otherStreams[Streams_id].play(Streams_id);
                                    });
                                })
                            }
                            console.log('stream-added remote-uid: ', id);
                        });

                        console.log("init success");

                        that.rtc.client.join(that.option.token ? that.option.token : null, that.option.channel, that.option.uid ? +that.option.uid : null, function (uid) {

                            console.log("join channel: " + that.option.channel + " success, uid: " + uid);

                            that.userInfo.push({
                                'uid': uid,
                                'video': that.video,
                                'audio': that.audio,
                                'Streams_id': 'video_' + uid,
                                'TransportDelay': 1,
                            });

                            that.rtc.params.uid = uid;

                            let rtm_uid = 'agora_' + String(uid);
                            that.$http.get('https://api.x300.xloong.com/index.php?api=get_rtm_token&hubName=xloong&uid='+rtm_uid)
                                .then(function (response) {
                                    that.rtm.client.login({token: response.data.data, uid: rtm_uid}).then(() => {
                                        console.log('AgoraRTM client login success');

                                        that.channel.join().then(() => {
                                            /* 加入频道成功的处理逻辑 */
                                            that.channel.on('ChannelMessage', ({text}, senderId) => { // text 为收到的频道消息文本，senderId 为发送方的 User ID
                                                /* 收到频道消息的处理逻辑 */
                                                let index = text.lastIndexOf("_");
                                                let suffix = text.substr(index + 1);
                                                let content = text.substr(0, index);
                                                that.messageList.push({
                                                    'message': content,
                                                    'userId': senderId,
                                                    'self': false,
                                                    'nickname': suffix,
                                                });
                                                if (that.mess) {
                                                    that.unread++;
                                                }
                                            });
                                            setInterval(function () {
                                                that.get_other_status();
                                            }, 5000);
                                        }).catch(error => {
                                            /* 加入频道失败的处理逻辑 */
                                        });
                                    }).catch(err => {
                                        console.log('AgoraRTM client login failure', err);
                                    });
                                }).catch(function (error) {
                                console.log(error);
                                this.$message.error('获取RTM token失败，稍后刷新重试！');
                            });

                            that.rtc.localStream = that.AgoraRTC.createStream({
                                streamID: that.rtc.params.uid,
                                audio: true,
                                video: true,
                                screen: false,
                                microphoneId: that.audio_id,
                                cameraId: that.video_id,
                            });
                            that.rtc.localStream.init(function () {
                                that.rtc.localStream.play('agora-player-main');

                                that.rtc.localStream.setVideoProfile(that.video_type[that.Resolution]);

                                if (!that.video)
                                    that.rtc.localStream.disableVideo();
                                if (!that.audio)
                                    that.rtc.localStream.disableAudio();

                                that.rtc.client.publish(that.rtc.localStream, function (err) {
                                    console.log("publish failed");
                                    console.error(err);
                                })

                                $('.drag1').dragDiv({direction:"left"});
                                // $('.drag2').dragDiv({direction:"top"});
                                $('.drag3').dragDiv({direction:"bottom"});
                            }, function (err) {
                                console.error("init local stream failed ", err);
                            });

//                    that.rtc.client.on('network-quality',function (evt) {
//                        console.log(evt);
//                    });
                            that.rtc.client.on('client-banned', function (evt) {
                                console.log(evt);
                                var uid = evt.uid;
                                that.set_leave()
                            })

                            that.rtc.client.on("crypt-error", function (evt) {
                                console.log(evt);
                            });
                        }, function (err) {
                            console.error("client join failed", err)
                        })

                        that.rtc.client.on("peer-leave", function (evt) {
                            var id = evt.uid;
                            var Streams_id = 'video_' + id;

                            //中间视频用户下线
                            if (that.mainList[0] == Streams_id) {
                                //左侧若还有，则移动至中间
                                let isHave = true;
                                for (let i in that.userInfo) {
                                    if (that.userInfo[i].uid != that.rtc.params.uid && that.userInfo[i].Streams_id != that.mainList[0]) {
                                        isHave = false;
                                        that.move_main(that.userInfo[i].Streams_id,id);
                                        break;
                                    }
                                }

                                if (isHave) {
                                    that.userInfo.forEach(function (item, index) {

                                        if (item.uid == id) {
                                            that.userInfo.splice(that.userInfo.indexOf(item), 1);
                                            that.rtc.otherStreams.splice(that.rtc.otherStreams.indexOf(Streams_id), 1);
                                            that.mainList.splice(0,1);
                                        }

                                    });
                                }
                            } else {
                                that.userInfo.forEach(function (item, index) {

                                    if (item.uid == id) {
                                        that.userInfo.splice(that.userInfo.indexOf(item), 1);
                                        that.rtc.otherStreams.splice(that.rtc.otherStreams.indexOf(Streams_id), 1);
                                    }

                                });
                            }

                        })
                    }, (err) => {
                        console.error(err);
                    });

                }).catch(function (error) {
                console.log(error);
                this.$message.error('获取RTC token失败，稍后刷新重试！');
            });

            setInterval(function(){
                ++that.is_move;
                ++that.is_left;
            },1000);
        },
        methods:{
            //鼠标移动，显示上下
            mousemove: function () {
                this.is_move = 0;
            },
            //鼠标移动，显示左侧按钮滚动条
            mousemoveLeft: function() {
                this.is_left = 0;
            },
            //关闭自己的视频
            close_video(){
                let that = this;
                that.show_main_video = !that.show_main_video;
            },
            //关闭本地视频
            upd_video(){
                let that = this;
                that.video = !that.video;
                if (that.video) {
                    that.rtc.localStream.unmuteVideo();
                } else {
                    that.rtc.localStream.muteVideo();
                }
                that.upd_media(that.rtc.params.uid,'video');
            },
            //关闭本地音频
            upd_audio(){
                let that = this;
                that.audio = !that.audio;
                if (that.audio) {
                    that.rtc.localStream.unmuteAudio();
                } else {
                    that.rtc.localStream.muteAudio();
                }
                that.upd_media(that.rtc.params.uid,'audio');
            },
            upd_media(uid,type){
                let that = this;
                that.userInfo.forEach(function (item, index) {
                    if (item.uid == uid) {
                        if (type=='audio'){
                            that.userInfo[index].audio = !that.userInfo[index].audio;
                        } else {
                            that.userInfo[index].video = !that.userInfo[index].video;
                        }
                    }
                })
            },
            //开启关闭其他音视频
            upd_other_media(uid,type){
                let that = this;
                that.userInfo.forEach(function (item, index) {
                    if (item.uid == uid) {
                        let Streams_id = 'video_'+uid;
                        if (type=='audio'){
                            that.userInfo[index].audio = !that.userInfo[index].audio;
                            if (that.userInfo[index].audio)
                                that.rtc.otherStreams[Streams_id].unmuteAudio();
                            else
                                that.rtc.otherStreams[Streams_id].muteAudio();
                        } else {
                            that.userInfo[index].video = !that.userInfo[index].video;
                            if (that.userInfo[index].video)
                                that.rtc.otherStreams[Streams_id].unmuteVideo();
                            else
                                that.rtc.otherStreams[Streams_id].muteVideo();
                        }
                    }
                })
            },
            //关闭本地音视频流
            set_leave(){
                let that = this;
                that.rtc.client.leave(function () {
                    that.rtc.localStream.stop();
                    that.rtc.localStream.close();
                    while (that.rtc.remoteStreams.length > 0) {
                        var stream = that.rtc.remoteStreams.shift();
                        var id = stream.getId();
                        stream.stop();
                    }
                }, function (err) {
                    console.error(err);
                });
                that.rtm.client.logout();
                that.channel.leave();
                this.$router.push({path:'/'})
            },
            //点击左侧视频，移动到中间部门
            move_main(video_id,remove_id=false){
                let that = this;
                //将中间停止后 原有的添加到左侧
                if (that.mainList.length > 0){
                    var play_left = that.mainList[0];
//                    that.mainList[0] = '';
                    that.mainList.splice(0,1);
                    that.rtc.otherStreams[play_left].stop();

                    that.$nextTick(function() {
                        that.rtc.otherStreams[play_left].play(play_left);
                    });
                }

                //停止并移除左侧
                console.log(video_id);
                that.rtc.otherStreams[video_id].stop();

                that.$nextTick(function () {
                    //添加至中间
                    that.mainList[0] = video_id;
                    that.$nextTick(function () {
                        setTimeout(function () {
                            that.rtc.otherStreams[video_id].play(video_id);

                                if (remove_id) {
                                    that.userInfo.forEach(function (item, index) {

                                        if (item.uid == remove_id) {
                                            that.userInfo.splice(that.userInfo.indexOf(item), 1);
                                            that.rtc.otherStreams.splice(that.rtc.otherStreams.indexOf('video_' + remove_id), 1);
                                        }
                                    });
                                }
                        },2000);
                    });
                });
            },
            //发送消息
            send_message(){
                let that = this;
                if (that.message != ''){
                    that.channel.sendMessage({ text: that.message+'_'+that.nickname }).then(() => {
                        /* 频道消息发送成功的处理逻辑 */
                        that.messageList.push({
                            'message': that.message,
                            'self': true,
                            'userId': that.rtc.params.uid,
                            'nickname': that.nickname,
                        });
                        that.message = '';
                    }).catch(error => {
                        /* 频道消息发送失败的处理逻辑 */
                    });
                }
            },
            //获取用户名（暂无）
            getUserName(value){
                let that = this;
                let index = value.lastIndexOf("_");
                let suffix = value.substr(index+1);
                if (that.userInfo.hasOwnProperty(suffix)){
                    return that.userInfo[suffix].nickname;
                } else {
                    return suffix;
                }
            },
            //是否显示消息
            set_right_mess(){
                let that = this;
                that.mess = !that.mess;
                that.right_show = (!that.mess || !that.people);
                if (!that.mess){
                    that.unread = 0;
                }
            },
            //设置是否显示人员信息
            set_right_people(){
                let that = this;
                that.people = !that.people;
                that.right_show = (!that.mess || !that.people);
            },
            //设备信息
            device(){
                let that = this;
                that.local.client = that.AgoraRTC.createClient({mode: "rtc", codec: "h264"});

                that.AgoraRTC.getDevices(function(devices){
                    let video = [];
                    let audio = [];
                    var audioDevices = devices.filter(function(device){
                        if (device.kind === "audioinput"){
                            audio.push({value:device.deviceId,label:device.label});

                            if (that.audio_id == '') {
                                that.audio_id = device.deviceId;
                            }
                        }
                    });
                    var videoDevices = devices.filter(function(device){
                        if (device.kind === "videoinput"){
                            video.push({value:device.deviceId,label:device.label});

                            if (that.video_id == '') {
                                that.video_id = device.deviceId;
                            }
                        }
                    });
                    that.device_video = video;
                    that.device_audio = audio;

                    var uid = Math.floor(Math.random()*10000);
                    that.preview = 'preview'+uid;
                    that.stream = that.AgoraRTC.createStream({
                        streamID: uid,
                        // Set audio to true if testing microphone
                        audio: true,
                        microphoneId: that.audio_id,
                        // Set video to true if testing camera
                        video: true,
                        cameraId: that.video_id,
                        screen: false
                    });

                    // Initialize the stream
                    that.stream.init(function(){
                        that.stream.play('preview'+uid);
                        that.stream.setVideoProfile(that.video_type[that.Resolution]);
                    })
                });
            },

            //修改音频输入
            set_audio(){
                let that = this;
                that.set_local_leave();
                that.device();
            },
            //修改视频输入
            set_video(){
                let that = this;
                that.set_local_leave();
                that.device();
            },
            //设置画质清晰度
            set_Profile(){
                let that = this;
                that.set_local_leave();
                that.device();
            },
            //关闭本地音视频流
            set_local_leave(){
                let that = this;
                that.local.client.leave(function () {
                    that.stream.stop();
                    that.stream.close();
                }, function (err) {
                    console.error(err);
                });
            },
            //修改音视频设备、画质
            submitDevice(){
                let that = this;
                localStorage.setItem('video_id',that.video_id);
                localStorage.setItem('audio_id',that.audio_id);
                localStorage.setItem('resolution',that.Resolution);

                //修改发布视频流
                that.rtc.localStream.switchDevice("video",that.video_id);
                that.rtc.localStream.switchDevice("audio",that.audio_id);

                that.rtc.localStream.setVideoProfile(that.video_type[that.Resolution]);

                that.set_local_leave();
                that.show_setting = 0;
            },
            //显示版本
            show_version(){
                let that = this;
                that.version_num >= 2 ? that.version_num = 0 : ++that.version_num;
            },
            //移除用户。headers(需要后期根据接口替换)
            move_people(uid) {
                let that = this;
                that.$http.post('/kicking-rule/',{
                    "appid":that.option.appID,   // 控制台中项目的 App ID，必填
                    "cname":that.room,   // channel name 频道名称，非必填，可以不传，但不能传 cname:""
                    "uid":uid,     // uid，SDK 可以获取到，非必填，可以不传，但不能传 uid:0
                    "time": 1    // 封人时间，单位是分钟，最大 1440 分钟，最小一分钟。如果大于 1440 分钟，会被处理成 1440 分钟，如果不传默认为 1 小时。非必填。比如：time:60
                },{
                    headers: {
                        'Authorization': 'Basic MTA3ZjMwM2YyNTVjNDYwNTgyY2E5NDE0ODJhNTU2NGM6Zjg2YmNkYmRlNGVmNGE5NWI2N2ZhZjY4NjI2M2MzYTY='
                    }
                }).then(function (response) {
                    console.log(response);
                }).catch(function (error) {
                    console.log(error);
                });
            },
            //修改passwor等（暂时没用）
            submitPassword(){
                let that = this;
                localStorage.setItem('password',that.password);
                localStorage.setItem('default_camera',that.default_camera);
                localStorage.setItem('default_microphone',that.default_microphone);
                that.show_setting = 0;
            },
            //获取远端订阅流的统计数据
            get_other_status(){
                let that = this;
                that.rtc.client.getRemoteAudioStats((remoteAudioStatsMap) => {
                    for(var uid in remoteAudioStatsMap){
                        that.userInfo.forEach(function (item,index) {
                            if (item.uid == uid){
                                that.userInfo[index].TransportDelay = remoteAudioStatsMap[uid].TransportDelay;
                            }
                        });
                        // console.log(`Audio CodecType from ${uid}: ${remoteAudioStatsMap[uid].CodecType}`);
                        // console.log(`Audio End2EndDelay from ${uid}: ${remoteAudioStatsMap[uid].End2EndDelay}`);
                        // console.log(`Audio MuteState from ${uid}: ${remoteAudioStatsMap[uid].MuteState}`);
                        // console.log(`Audio PacketLossRate from ${uid}: ${remoteAudioStatsMap[uid].PacketLossRate}`);
                        // console.log(`Audio RecvBitrate from ${uid}: ${remoteAudioStatsMap[uid].RecvBitrate}`);
                        // console.log(`Audio RecvLevel from ${uid}: ${remoteAudioStatsMap[uid].RecvLevel}`);
                        // console.log(`Audio TotalFreezeTime from ${uid}: ${remoteAudioStatsMap[uid].TotalFreezeTime}`);
                        // console.log(`Audio TotalPlayDuration from ${uid}: ${remoteAudioStatsMap[uid].TotalPlayDuration}`);
                        console.log(`Audio TransportDelay from ${uid}: ${remoteAudioStatsMap[uid].TransportDelay}`);
                    }
                });
            },
            //移动用户列表
            move_video(type){
                let that = this;
                let t = that.$refs.movieLeft.scrollTop;
                if (type === 'up') {
                    that.$refs.movieLeft.scrollTo(0,168+t);
                } else {
                    that.$refs.movieLeft.scrollTo(0,t-168);
                }
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    body {
        font-family: Futura, sans-serif !important;
        font-feature-settings: "tnum";
        font-variant: tabular-nums;
        line-height: 1.5;
        font-size: 20px;
        overflow-x: hidden;
        min-height: 760px;
    }

    #Meeting {
        overflow: hidden;
    }

    .container {
        min-height: 100%;
        height: 100%;
        position: relative;
    }

    #Meeting .header {
        position: absolute;
        z-index: 20;
        width: 100%;
        padding: .5rem 1.8rem;
        height: 3rem;
        top: 0;
        left: 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        box-shadow: 0 2px 10px 2px rgba(0, 0, 0, .1);
        background: #f5f5f5;
        transition: all .3s ease-in-out;
    }

    #Meeting .header .header-item:first-child {
        justify-content: flex-start;
    }

    #Meeting .header .header-item {
        display: flex;
        justify-content: center;
        align-items: center;
        flex: 1 1 9rem;
        font-size: 1rem;
        color: #666;
        font-weight: 700;
    }

    #Meeting .footer {
        position: absolute;
        box-sizing: border-box;
        width: 100%;
        z-index: 20;
        padding: .5rem 1.8rem;
        height: 3.6rem;
        bottom: 0;
        left: 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        box-shadow: 0 -2px 10px 2px rgba(0, 0, 0, .1);
        background: #f5f5f5;
        transition: all .3s ease-in-out;
        overflow: hidden;
    }

    #Meeting .header.shrink {
        height: 2.25rem;
        background: transparent;
        box-shadow: none;
    }

    #Meeting .footer.hide {
        bottom: -3.6rem;
    }

    .icon-btn {
        display: inline-block;
        margin: 0 .1rem;
        cursor: pointer;
        width: 2.5rem;
        height: 2.5rem;
    }

    #Meeting .main {
        position: relative;
        padding-top: 2.25rem;
        background-clip: content;
        height: 100%;
        background: url('/static/images/logo_bg.png') #ccc 50% no-repeat;
    }

    .carousel {
        z-index: 100;
        -webkit-transform: translateZ(0);
        transform: translateZ(0);
        position: absolute;
        height: 100%;
        width: 10rem;
        left: 0;
        top: 0;
        margin: 0;
        padding: 2.5rem 0 0;
        transition: all .3s ease-in-out;
    }

    .carousel .backdrop {
        position: absolute;
        background: rgba(0, 0, 0, .4);
        -webkit-backdrop-filter: blur(.75rem);
        backdrop-filter: blur(.75rem);
        left: 0;
        right: 1.1rem;
        top: 0;
        bottom: 0;
        pointer-events: none;
    }

    .carousel .container {
        list-style-type: none;
        /*overflow: scroll;*/
        margin: 0;
        padding: 0;
    }

    .carousel .side-panel {
        position: absolute;
        display: flex;
        z-index: 3;
        top: 0;
        bottom: 0;
        right: 0;
        left: 8.9rem;
        justify-content: center;
        flex-direction: column;
    }

    .carousel .side-panel .vpanel-control-wrapper {
        cursor: pointer;
        height: 10rem;
        width: 100%;
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
        display: flex;
        align-items: center;
        background-size: contain;
        background-repeat: no-repeat;
        background-image: url('/static/images/left-bg.png');
        background-position-x: -1px;
    }

    .carousel.expanded .vpanel-control-wrapper .control {
        width: 100%;
        height: 5rem;
        background-image: url('/static/images/left.png');
        background-size: 50%;
        background-repeat: no-repeat;
        background-position-y: center;
        position: absolute;
        left: -.5rem;
        transition: all .3s ease-in-out;
    }

    #Meeting .right-panel {
        position: absolute;
        color: #333;
        z-index: 21;
        top: 0;
        right: 0;
        transition: all .3s ease-in-out;
        width: 16rem;
        height: 100%;
        box-shadow: -2px 0 10px 2px rgba(0,0,0,.1);
        background: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-flow: column;
    }

    .message-list-container {
        background: #fff;
        padding: .3rem;
        width: 16rem;
        display: flex;
        flex-flow: column;
    }

    .message-list-header {
        width: 100%;
        height: 2.5rem;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: .9rem;
        position: relative;
    }

    .anticon {
        display: inline-block;
        font-style: normal;
        vertical-align: -.125em;
        text-align: center;
        text-transform: none;
        line-height: 0;
        text-rendering: optimizeLegibility;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

    .message-list-box {
        flex-grow: 1;
        overflow-y: auto;
        scroll-behavior: smooth;
    }

    .ant-divider {
        font-family: Chinese Quote,-apple-system,BlinkMacSystemFont,Segoe UI,PingFang SC,Hiragino Sans GB,Microsoft YaHei,Helvetica Neue,Helvetica,Arial,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol;
        font-size: 14px;
        -webkit-font-feature-settings: "tnum";
        font-feature-settings: "tnum";
        font-variant: tabular-nums;
        line-height: 1.5;
        color: rgba(0,0,0,.65);
        box-sizing: border-box;
        margin: 0;
        padding: 0;
        list-style: none;
        background: #e8e8e8;
    }

    .ant-divider, .ant-divider-vertical {
        margin: 0 8px;
        display: inline-block;
        height: .9em;
        width: 1px;
        vertical-align: middle;
        position: relative;
        top: -.06em;
    }

    .ant-divider-horizontal {
        display: block;
        height: 1px;
        width: 100%;
        min-width: 100%;
        margin: 24px 0;
        background: #e8e8e8;
        clear: both;
    }

    .message-control {
        display: flex;
        justify-content: center;
        align-items: center;
        /*opacity: .3;*/
        transition: opacity .1s ease-in;
    }

    .agora-player__box {
        position: relative;
        width: 240px;
        height: 180px;
    }

    .video_show{
        transform: scale(1, 1);
    }

    .video_hide{
        transform: scale(0, 0);
    }

    .carousel .container .carousel-item {
        width: 7.5rem;
        margin: .9rem;
        height: 7.5rem !important;
        overflow: hidden;
        position: relative;
        border-radius: .3rem;
    }

    .agora-player__label {
        position: absolute;
        text-align: center;
        font-size: 16px;
        font-weight: 700;
        color: #fff;
        height: 24px;
        width: 100%;
        bottom: 0;
        z-index: 2;
        right: 0;
    }

    .carousel.collapsed{
        left: -8.9rem;
    }

    .carousel.collapsed .vpanel-control-wrapper{
        background-image:url("/static/images/left-hide-bg.png");
    }

    .carousel.collapsed .vpanel-control-wrapper .control {
        width: 100%;
        height: 5rem;
        background-image: url('/static/images/right.png');
        background-size: 50%;
        background-repeat: no-repeat;
        background-position-y: center;
        position: absolute;
        left: -.1rem;
        transition: all .3s ease-in-out;
    }

    .message-item {
        display: flex;
        align-items: center;
        padding: 6px 12px;
    }

    .message-item-sender {
        display: flex;
        flex-direction: row-reverse;
        align-items: center;
        padding: 6px 12px;
    }

    .message-item-sender .message-label {
        margin-left: .5rem;
        margin-right: 0;
        text-align: right;
    }

    .message-label {
        color: #333;
        font-size: .7rem;
        font-weight: 700;
        width: 3rem;
        margin-right: .5rem;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .message-detail {
        color: #666;
        word-wrap: break-word;
        max-width: 9.5rem;
        font-size: .7rem;
    }

    .ant-dropdown{
        padding: 0;
        min-width: auto;
    }

    .ant-dropdown-menu {
        outline: none;
        position: relative;
        /*list-style-type: none;*/
        padding: 4px 0;
        margin: 0;
        text-align: left;
        background-color: #fff;
        border-radius: 4px;
        /*box-shadow: 0 2px 8px rgba(0,0,0,.15);*/
        background-clip: padding-box;
    }

    .ant-dropdown-menu-item{
        padding: 5px 12px;
        margin: 0;
        clear: both;
        font-size: 14px;
        font-weight: 400;
        color: rgba(0,0,0,.65);
        white-space: nowrap;
        cursor: pointer;
        transition: all .3s;
        line-height: 22px;
        list-style-type: none;
        font-family: Chinese Quote,-apple-system,BlinkMacSystemFont,Segoe UI,PingFang SC,Hiragino Sans GB,Microsoft YaHei,Helvetica Neue,Helvetica,Arial,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol;
    }

    .ant-dropdown-menu-item:hover{
        background-color: #eee!important;
    }

    .with-modal-mask {
        position: fixed;
        top: 0;
        left: 0;
        z-index: 30;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        background: hsla(0,0%,84.7%,.7);
    }

    .ant-card {
        width: 360px;
        box-shadow: rgba(222, 222, 222, 0.5) 0px 6px 8px 3px;
        font-family: Chinese Quote, -apple-system, BlinkMacSystemFont, Segoe UI, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol;
        font-size: 14px;
        -webkit-font-feature-settings: "tnum";
        font-feature-settings: "tnum";
        font-variant: tabular-nums;
        line-height: 1.5;
        color: rgba(0, 0, 0, .65);
        box-sizing: border-box;
        margin: 0;
        padding: 0;
        list-style: none;
        background: #fff;
        border-radius: 4px;
        position: relative;
        transition: all .3s;
        border: 1px solid #e8e8e8;
    }

    .ant-card-body {
        padding: 24px;
        zoom: 1;
    }

    .ant-card-body:before {
        content: "";
        display: table;
    }

    .preview-window {
        width: 6rem;
        height: 6rem;
        margin: .5rem;
        background: #fafafa;
    }

    #Meeting .header.shrink .header-item:first-child {
        display: none;
    }

    #Meeting .header.shrink .header-item:nth-child(2) {
        color: #fff;
        background: rgba(51,51,51,.4);
        border-radius: 100px;
        margin: 0 auto;
    }

    #Meeting .header.shrink .header-item:nth-child(3) {
        display: none;
    }

    #Meeting .header .header-item:first-child {
        justify-content: flex-start;
    }

    #Meeting .header .header-item:nth-child(3) {
        justify-content: flex-end;
    }

    #Meeting .header .header-item .room {
        line-height: 30px;
    }

    .user-list-box {
        flex-grow: 1;
        overflow-y: auto;
        scroll-behavior: smooth;
        margin-bottom: 1rem;
    }

    .user-item {
        display: flex;
        align-items: center;
        padding: 6px 12px;
    }

    .user-item .user-info {
        flex: 1 1 auto;
        font-weight: 700;
        font-size: 12px;
    }

    .user-item .user-control {
        flex: 0 0 6.5rem;
        display: flex;
        justify-content: space-around;
        align-content: center;
    }

    .scrollBtn {
        width: 2rem;
        height: 2rem;
        background: rgba(0, 0, 0, .3);
        -webkit-backdrop-filter: blur(.75rem);
        backdrop-filter: blur(.75rem);
        background-size: 50%;
        background-repeat: no-repeat;
        background-position: 50%;
        position:absolute;
        left: 3.5rem;
        cursor: pointer;
    }

    .scrollBtn.scrollUp {
        pointer-events: auto;
        cursor: pointer;
        top: 4.6rem;
        background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHAAAAA+CAYAAADzsp9XAAAAAXNSR0IArs4c6QAAAvpJREFUeAHt3U9OwlAQBnCQAzRwGdeuvBI7deeVPIKXAXsAUjumz0hty3t98+ebCSSkQNt5M98v0dBF2WwCP9q2faRn4BHjjkZwp9Ppi56REbcRCQnscrl89LM1w3ztbrd7bprmM9q84QAn8JJZSMRQgAt4YRHDAGbghUQMAViAFw7RPeAKvFCIrgEr8MIgugVkwAuB6BKQEc89ojvAQrx2EEpf6BPY1Nbl90RXgKV4dPWFpEZXZabw0mfuEN0ArsFLl85qzk2yqFsXgBwAHDUQEeEBOYPnrIWCCQ0oEbhETUtMWEDJoCVra2NCAmoErLGGBiYcoGawmmtJYUIBWgRqsSYnJgygZZCWa9diQgAiBIjQwxpMc0Ck4JB6ycU0BUQMDLGnJUwzQOSgkHsbY5oAegjIQ4+EqQ7oJRgKx0OvqoAeAiG4vw/0ntUA0YP4izZ+jdy7CiByAGOsufeoM4gDog4+B7X0OeIsooCIAy8B5exDm0kMEG3QHJzcY5BmEwFEGjAXpfQ4lBnZAVEGKwVZczzCrKyACAOtgag5x3pmNkDrQWoQas+1nJ0F0HKA2vC5zrfKoBrQqnGu4DnrWGRRBWjRMGfgErW0M1kNqN2oRNhSNTWzWQWo2aBUyNJ1tTIqBtRqTDpgjfoaWRUBajSkEazmGtKZZQNKN6IZqvZaktllAUo2oB2m1XpSGd4ElFrYKkjLdSWyXASUWNAyQIS1uTOdBeReCCE8lB44s50E5FwAJTS0Prgy/gfIVRgtMMR+OLK+AuQoiBgUck+1mf8C1hZCDgm9t5rsfwBrCqCH46W/tQYPNGB/K6qnfhP2fmIeEOmuUsOtwdL93ZbabgazzQ/g4XB43263b0tn9Pvc3Ufsxjxwu3MRyYrMaIDf/4H05nw+v3Zd90KvR4873igQybdLf04Jb7/fv6b1rwDpwwnEO15KS3E7hTjGm22HEPtfPOmi/+rJbAAgOwhx+PWZjkyK2upPPFKBopPuB7MnMCAe2QvfC2Ik8A2QbM0//dcLVgAAAABJRU5ErkJggg==)
    }

    .scrollBtn.scrollDown {
        pointer-events: auto;
        cursor: pointer;
        bottom: 4.6rem;
        background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHAAAAA+CAYAAADzsp9XAAAAAXNSR0IArs4c6QAAAqVJREFUeAHt3U1WwjAQB3ArB+iDy3gEr6QrcaVXcuXaywA9AA/7R4IF2rRpJsnMMHmPF0jzMZkfUFhQHh6s6MzAZrN5aZrmSefu5OwKBrAIini73a7bQYf2tjPEoNSRdj7h7WABk77Jq+tGdDwcDm+d9maxWDzXdf3TabO7iTMAvP1+/9UuU7ulqqp6Xy6Xa/cY9QVgD57ra4guExnqPjy37DXiGdCD58YaostEwtqH55btIh4BTyfJD9fBUxuiJzmxh6bgddZ4Xa1Wn49oaM9x323VdA4O3a3xvoyFhjpY+7wMBOLhhQSz/3PgjAnsg808q5tRMbk/nwMxa8xEN1FZw6QMxOb8AhArxk44KWrrdMwARa5vADEzxcRm5M8AVY57AQ3Rn/zYo1R4iGMQEAcpF8J8Vuhz6gVEwg2R7mmXIpejgIZIA5gCD5FNAjTEOMRUeEGAhjgPMSVeMKAhhiGmxpsFaIjTEHPgzQY0RD9iLrwoQEPsR8yJFw1oiJeIufFIAA3xD7EEHhngvSOWwiMFvFfEknjkgPeGWBovCeC9IHLASwaoHZELXlJArYic8JIDakPkhpcFUAsiR7xsgNIRueJlBZSKyBkvO6A0RO54RQClIErAKwbIHVEKXlFAroiS8IoDckOUhscCkAuiRDw2gKURpeKxAiyFKBmPHWBuROl4LAFzIWrAYwuYGlELHmvAVIia8NgDUiNqwxMBSIWoEU8MYCyiVjxRgHMRMe76qn9oGyjiLiU2+Re6AxvO3hz6ajoFeL5koydgcXjYizhABB2IiCFjRSQeNiUSEIETIorFEw1IhCgaTzxgJKJ4PBWAMxFV4KkBDERUg6cKcCKiKjx1gCOI6vBUAg4gqsTDXtUWfE/EP8/Yv88IJgYiboK3MBr6Lz9K2VQ4+JDXAAAAAElFTkSuQmCC)
    }


    .drag1 {
        border: 1px transparent solid;
        width: 4px;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        cursor: col-resize;
        /*background: #000;*/
        z-index: 9;
    }

    .drag3 {
        border: 1px transparent solid;
        width: 100%;
        height: 4px;
        position: absolute;
        bottom: 0;
        left: 0;
        cursor: row-resize;
        /*background: #000;*/
        z-index: 9;
    }
</style>



// WEBPACK FOOTER //
// src/components/Main.vue